const VideoCardSkeleton = () => (
  <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden h-full">
    {/* Video Player Skeleton */}
    <div className="h-40 sm:h-52 relative bg-gray-200 animate-pulse">
      <div className="absolute top-3 right-3">
        <div className="w-12 h-6 bg-gray-300 rounded-full animate-pulse"></div>
      </div>
    </div>

    {/* Content Section Skeleton */}
    <div className="p-4 space-y-3 flex-1">
      {/* Brand Header Skeleton */}
      <div className="flex items-center gap-3">
        <div className="w-8 h-8 rounded-full bg-gray-300 animate-pulse"></div>
        <div className="flex-1 min-w-0">
          <div className="w-20 h-4 bg-gray-300 rounded animate-pulse mb-1"></div>
          <div className="w-16 h-3 bg-gray-200 rounded animate-pulse"></div>
        </div>
      </div>

      {/* Caption Skeleton */}
      <div className="space-y-2">
        <div className="w-full h-3 bg-gray-200 rounded animate-pulse"></div>
        <div className="w-3/4 h-3 bg-gray-200 rounded animate-pulse"></div>
      </div>

      {/* Stats Row Skeleton */}
      <div className="flex justify-between items-center pt-2 border-t border-gray-50">
        <div className="flex items-center gap-1">
          <div className="w-4 h-4 bg-gray-300 rounded animate-pulse"></div>
          <div className="w-8 h-4 bg-gray-300 rounded animate-pulse"></div>
        </div>
        <div className="flex items-center gap-1">
          <div className="w-4 h-4 bg-gray-300 rounded animate-pulse"></div>
          <div className="w-6 h-4 bg-gray-300 rounded animate-pulse"></div>
        </div>
      </div>
    </div>
  </div>
);

export default VideoCardSkeleton;
